module.exports = {"513326100":"鲜水镇","513326101":"八美镇","513326102":"亚卓镇","513326104":"玉科镇","513326105":"仲尼镇","513326106":"泰宁镇","513326107":"瓦日镇","513326201":"麻孜乡","513326202":"孔色乡","513326203":"葛卡乡","513326207":"扎拖乡","513326208":"下拖乡","513326210":"木茹乡","513326211":"甲斯孔乡","513326213":"七美乡","513326214":"银恩乡","513326216":"龙灯乡","513326218":"色卡乡","513326219":"沙冲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513326.json
// module id = 2548
// module chunks = 0